"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5255],{

/***/ 28116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var client_icons_ChevronDown__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11910);
/* harmony import */ var client_icons_ChevronUp__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87282);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89683);






var CollapsibleSection = function(param) {
    var title = param.title, children = param.children, iconToOpen = param.iconToOpen, iconToClose = param.iconToClose, _initialState = param.initialState, initialState = _initialState === void 0 ? false : _initialState, _fullWidth = param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(initialState), showMore = ref[0], setShowMore = ref[1];
    var IconToOpen = iconToOpen || client_icons_ChevronDown__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z;
    var IconToClose = iconToClose || client_icons_ChevronUp__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_4__/* .CollapsibleSectionBase */ .J2, {
        fullWidth: fullWidth,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_4__/* .Header */ .h4, {
                onClick: function() {
                    return setShowMore(!showMore);
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_4__/* .Title */ .Dx, {
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_4__/* .IconWrapper */ .a1, {
                        children: showMore ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconToClose, {
                            "data-testid": "collapsible-close-icon"
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconToOpen, {
                            "data-testid": "collapsible-open-icon"
                        })
                    })
                ]
            }),
            showMore && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_4__/* .Content */ .VY, {
                "data-testid": "collapsible-content",
                children: children
            })
        ]
    });
};
CollapsibleSection.propTypes = {
    title: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string.isRequired),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().node.isRequired),
    initialState: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool),
    fullWidth: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool),
    iconToOpen: prop_types__WEBPACK_IMPORTED_MODULE_5___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_5___default().any)),
    iconToClose: prop_types__WEBPACK_IMPORTED_MODULE_5___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_5___default().any))
};
/* harmony default export */ __webpack_exports__["Z"] = (CollapsibleSection);


/***/ }),

/***/ 89683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* binding */ Title; },
/* harmony export */   "J2": function() { return /* binding */ CollapsibleSectionBase; },
/* harmony export */   "VY": function() { return /* binding */ Content; },
/* harmony export */   "a1": function() { return /* binding */ IconWrapper; },
/* harmony export */   "h4": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12411);
/* harmony import */ var client_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89804);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-start;\n  background: ",
        ";\n  border: 2px solid ",
        ";\n  border-radius: 8px;\n  padding-block: 20px;\n  padding-inline: 20px;\n  width: 100%;\n  min-width: 240px;\n\n  ",
        " {\n    max-width: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  cursor: pointer;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 25px;\n\n  color: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  font-size: 16px;\n  color: ",
        ";\n  line-height: 150%;\n  margin-block-start: 20px;\n  width: 100%;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fill: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var CollapsibleSectionBase = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__CollapsibleSectionBase",
    componentId: "sc-c4ef3156-0"
})(_templateObject(), client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.white */ .O9.white, client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.grey4 */ .O9.grey4, client_styles__WEBPACK_IMPORTED_MODULE_1__/* .media.mobile */ .BC.mobile, function(props) {
    return props.fullWidth ? "unset" : "350px";
});
var Header = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__Header",
    componentId: "sc-c4ef3156-1"
})(_templateObject1());
var Title = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__Title",
    componentId: "sc-c4ef3156-2"
})(_templateObject2(), client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.grey1 */ .O9.grey1);
var Content = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__Content",
    componentId: "sc-c4ef3156-3"
})(_templateObject3(), client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.grey2 */ .O9.grey2);
var IconWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__IconWrapper",
    componentId: "sc-c4ef3156-4"
})(_templateObject4(), client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.grey1 */ .O9.grey1);


/***/ }),

/***/ 94424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Rooms_BoardCode; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./client/components/Rooms/BoardCode/styles.js
var styles = __webpack_require__(20239);
// EXTERNAL MODULE: ./client/components/Rooms/RoomResponsive/OfferResponsive/Board/BoardIcon/index.tsx
var BoardIcon = __webpack_require__(76855);
;// CONCATENATED MODULE: ./client/components/Rooms/constants.js
var BOARD_CODE_ROOM_ONLY = "RO";
var BOARD_CODE_SELF_CATERING = "SC";
var BOARD_CODE_BED_BREAKFAST = "BB";
var BOARD_CODE_HALF_BOARD = "HB";
var BOARD_CODE_FULL_BOARD = "FB";

;// CONCATENATED MODULE: ./client/components/Rooms/BoardCode/index.js






var BoardCode = function(param) {
    var code = param.code, name = param.name;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* BoardCodeBase */.R, {
        color: code === BOARD_CODE_ROOM_ONLY ? "grey2" : "green",
        "data-testid": "board-code",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BoardIcon/* default */.Z, {
                code: code
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: name
            })
        ]
    });
};
BoardCode.propTypes = {
    code: (prop_types_default()).string.isRequired,
    name: (prop_types_default()).string.isRequired
};
/* harmony default export */ var Rooms_BoardCode = (BoardCode);


/***/ }),

/***/ 20239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ BoardCodeBase; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12411);
/* harmony import */ var client_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89804);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n\n  p {\n    color: ",
        ";\n    &::first-letter {\n      text-transform: uppercase;\n    }\n  }\n\n  svg {\n    fill: ",
        ";\n    margin-inline-end: 8px;\n    flex: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var BoardCodeBase = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__BoardCodeBase",
    componentId: "sc-f8fcac49-0"
})(_templateObject(), function(props) {
    return client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors */ .O9[props.color];
}, function(props) {
    return client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors */ .O9[props.color];
});


/***/ }),

/***/ 46409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "JY": function() { return /* binding */ OPTIONS; },
  "pF": function() { return /* binding */ confirmPurchase; },
  "sn": function() { return /* binding */ confirmPurchaseAuthorized; },
  "e5": function() { return /* binding */ confirmPurchaseWithApm; },
  "Qo": function() { return /* binding */ confirmPurchaseWithApplePay; },
  "dp": function() { return /* binding */ confirmWorldlinePurchase; },
  "g6": function() { return /* binding */ confirmWorldlinePurchaseAuthorized; },
  "it": function() { return /* binding */ createAlias; },
  "$5": function() { return /* binding */ createAliasVoucher; },
  "Xd": function() { return /* binding */ generateQuotePriceDropProtection; },
  "Q8": function() { return /* binding */ getPaymentMethods; },
  "yv": function() { return /* binding */ getPaymentStatus; },
  "MW": function() { return /* binding */ getPurchaseById; },
  "Zg": function() { return /* binding */ requestByPOST; },
  "LS": function() { return /* binding */ updatePurchaseById; },
  "QO": function() { return /* binding */ updatePurchaseByIdAuthorized; }
});

// UNUSED EXPORTS: confirmWorldlinePurchase3ds, createPurchase

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(50853);
// EXTERNAL MODULE: ../../node_modules/axios/lib/axios.js + 48 modules
var axios = __webpack_require__(60418);
// EXTERNAL MODULE: ./src/constants/environment.js
var environment = __webpack_require__(65003);
// EXTERNAL MODULE: ./lib/requests.js + 2 modules
var requests = __webpack_require__(68765);
// EXTERNAL MODULE: ./client/contexts/Purchase/mappers.ts
var mappers = __webpack_require__(75342);
// EXTERNAL MODULE: ./lib/utils/url.js
var url = __webpack_require__(70284);
// EXTERNAL MODULE: ./client/contexts/Tracking/utils.js + 1 modules
var utils = __webpack_require__(41639);
;// CONCATENATED MODULE: ./client/contexts/Purchase/utils.js


function buildCustomerDataInputsToBodyRequest(param) {
    var name = param.name, last = param.last, email = param.email, phone = param.phone, address = param.address, city = param.city;
    return {
        first_name: name,
        last_name: last,
        email: email,
        phone: phone,
        physical_address: address,
        physical_city: city
    };
}
function buildHolderInputsToBodyRequest(param) {
    var holders = param.holders;
    return {
        holders: holders.map(function(holder) {
            return {
                first_name: holder.name,
                last_name: holder.last,
                email: holder.email
            };
        })
    };
}
function buildSpecialRequestsInputsToBodyRequest(checkoutInputs) {
    var specialRequests = [
        checkoutInputs.bedPreference,
        checkoutInputs.checkInPreference,
        checkoutInputs.smokersRoomPreference,
        checkoutInputs.highRoomPreference,
        checkoutInputs.cradleRoomPreference,
        checkoutInputs.writeSpecialRequests, 
    ].filter(function(r) {
        return r;
    }).join(" - ").trim();
    if (!specialRequests) {
        return {};
    }
    return {
        requests: specialRequests
    };
}
function buildInsurancesInputsToBodyRequest(checkoutInputs) {
    var _boardsWihtInsurance = checkoutInputs.boardsWihtInsurance, boardsWihtInsurance = _boardsWihtInsurance === void 0 ? [] : _boardsWihtInsurance;
    if (boardsWihtInsurance.length === 0) {
        return {};
    }
    return {
        insurance_ids: boardsWihtInsurance.map(function(board) {
            return board.availabilityId;
        })
    };
}
function buildUpdatePurchaseToBodyRequest(params) {
    return (0,src_object_spread/* default */.Z)({
        purchase_id: params.purchaseId,
        property_id: params.propertyId,
        session_id: params === null || params === void 0 ? void 0 : params.sessionId,
        lang: params.language,
        market: params.market,
        source: "web"
    }, params.context && {
        context: params.context
    }, buildCustomerDataInputsToBodyRequest(params), buildHolderInputsToBodyRequest(params), buildSpecialRequestsInputsToBodyRequest(params), buildInsurancesInputsToBodyRequest(params));
}
function buildUpdateCustomerDataToBodyRequest(params) {
    return _object_spread({
        purchase_id: params.purchaseId,
        property_id: params.propertyId,
        session_id: params === null || params === void 0 ? void 0 : params.sessionId,
        lang: params.language,
        market: params.market,
        source: "web",
        context: params.context
    }, buildCustomerDataInputsToBodyRequest(params), buildHolderInputsToBodyRequest(params), buildSpecialRequestsInputsToBodyRequest(params), buildInsurancesInputsToBodyRequest(params));
}
function utils_buildCreatePurchaseRequest(param) {
    var availabilityIds = param.availabilityIds, insuranceIds = param.insuranceIds, context = param.context, market = param.market;
    return removeEmptyKeys({
        id_availabilities: availabilityIds,
        insurance_ids: insuranceIds,
        context: context,
        market: market
    });
}
function buildPurchaseByIdRequest(param) {
    var purchaseId = param.purchaseId;
    return {
        purchase_id: purchaseId
    };
}
function buildPurchasePaymentMethodByIdRequest(param) {
    var context = param.context, domain = param.domain, language = param.language, market = param.market, paymentProvider = param.paymentProvider, purchaseId = param.purchaseId;
    return {
        context: context,
        domain: domain,
        language: language,
        market: market,
        payment_provider: paymentProvider,
        purchase_id: purchaseId
    };
}
function buildConfirmPurchaseBodyRequest(param) {
    var purchaseId = param.purchaseId, language = param.language, isMobile = param.isMobile, affiliateId = param.affiliateId, domain = param.domain, affiliateData = param.affiliateData, sessionId = param.sessionId, platform = param.platform;
    return {
        domain: domain,
        purchase_id: purchaseId,
        language: language,
        is_mobile: isMobile,
        affiliate_name: affiliateId,
        affiliate_data: affiliateData,
        browserAcceptHeader: "application/json",
        browserColorDepth: "".concat(window.screen.colorDepth),
        browserTimeZone: "".concat(new Date().getTimezoneOffset()),
        browserJavaEnabled: false,
        browserScreenHeight: window.screen.height,
        browserScreenWidth: window.screen.width,
        session_id: sessionId,
        platform: platform
    };
}
function buildConfirmWorldlinePurchaseBodyRequest(param) {
    var purchaseId = param.purchaseId, language = param.language, isMobile = param.isMobile, affiliateId = param.affiliateId, domain = param.domain, sessionId = param.sessionId, hostedTokenizationId = param.hostedTokenizationId, returnUrl = param.returnUrl, async = param.async, platform = param.platform;
    return {
        domain: domain,
        purchase_id: purchaseId,
        language: language,
        is_mobile: isMobile,
        affiliate_name: affiliateId,
        browserAcceptHeader: "application/json",
        browserColorDepth: "".concat(window.screen.colorDepth),
        browserTimeZone: "".concat(new Date().getTimezoneOffset()),
        browserJavaEnabled: false,
        browserScreenHeight: window.screen.height,
        browserScreenWidth: window.screen.width,
        session_id: sessionId,
        Hostedtokenization: hostedTokenizationId,
        returnUrl: returnUrl,
        async: async,
        platform: platform
    };
}
function buildConfirmApplePayPurchaseBodyRequest(param) {
    var purchaseId = param.purchaseId, paymentData = param.paymentData, ephemeralKey = param.ephemeralKey, publicKey = param.publicKey, language = param.language, isMobile = param.isMobile, affiliateId = param.affiliateId, domain = param.domain, sessionId = param.sessionId, platform = param.platform;
    return {
        domain: domain,
        purchase_id: purchaseId,
        payment_data: paymentData,
        ephemeral_key: ephemeralKey,
        public_key: publicKey,
        language: language,
        is_mobile: isMobile,
        affiliate_name: affiliateId,
        browserAcceptHeader: "application/json",
        browserColorDepth: "".concat(window.screen.colorDepth),
        browserTimeZone: "".concat(new Date().getTimezoneOffset()),
        browserJavaEnabled: false,
        browserScreenHeight: window.screen.height,
        browserScreenWidth: window.screen.width,
        session_id: sessionId,
        platform: platform
    };
}
function buildCreateAliasBodyRequest(param) {
    var cardHolderName = param.cardHolderName, paytpvToken = param.paytpvToken, purchaseId = param.purchaseId;
    return {
        username: cardHolderName,
        paytpvToken: paytpvToken,
        purchase_id: purchaseId
    };
}


;// CONCATENATED MODULE: ./client/contexts/Purchase/requests.js










var OPTIONS = {
    timeout: 30000,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
    }
};
var OPTIONS_GET = {
    timeout: 30000,
    headers: {
        Accept: "application/json"
    }
};
var CONFIRMATION_OPTIONS = {
    timeout: 120000,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
    }
};
var CONFIRMATION_OPTIONS_GET = {
    timeout: 120000,
    headers: {
        Accept: "application/json"
    }
};
var END_POINTS = {
    CREATE_ALIAS_VOUCHER: "/paycomet/alias-voucher",
    CREATE_ALIAS: "/paycomet/alias",
    CREATE_PURCHASE: "/purchase_id",
    INSURANCE_QUOTES: "/insurance/quotes",
    PAYMENT_METHODS_PRIME: "/v1/prime/payment-methods",
    PAYMENT_METHODS: "/purchase/payment-methods",
    PURCHASE_BY_ID: "/purchase/checkout",
    PURCHASE_CONFIRMATION_APM: "/purchase/confirmation/{paymentProvider}",
    PURCHASE_CONFIRMATION: "/purchase/confirmation",
    PURCHASE_CONFIRMATION_AUTH: "/purchase/confirmation/member",
    WORLDLINE_PURCHASE_CONFIRMATION: "/v2/purchase/confirmation",
    WORLDLINE_PURCHASE_CONFIRMATION_AUTH: "/v2/purchase/confirmation/member",
    WORLDLINE_PURCHASE_CONFIRMATION_3DS: "/worldline/purchase/confirmation-3ds",
    WORLDLINE_APPLEPAY_CONFIRMATION: "/worldline/purchase/confirmation-mobile/apple_pay",
    UPDATE_PURCHASE_BY_ID: "/purchase/customer-data",
    UPDATE_PURCHASE_BY_ID_AUTH: "/purchase/customer-data/member",
    PRICE_DROP_PROTECTION_QUOTE_GENERATE: "/pdp/quote/generate",
    PURCHASE_STATUS: "/purchase/status?purchase_id={purchaseId}"
};
function deprecatedRequestByGET(endpoint, data) {
    return axios/* default.get */.Z.get("".concat(environment/* API_BASE_URL */.CT).concat(endpoint), (0,src_object_spread/* default */.Z)({
        params: data
    }, OPTIONS)).then(function(res) {
        return res.data;
    });
}
var defaultMapper = function(data) {
    return data;
};
function requestByPOST(param) {
    var _hostname = param.hostname, hostname = _hostname === void 0 ? environment/* API_BASE_URL */.CT : _hostname, endpoint = param.endpoint, data = param.data, _options = param.options, options = _options === void 0 ? OPTIONS : _options, _mapper = param.mapper, mapper = _mapper === void 0 ? defaultMapper : _mapper;
    return axios/* default.post */.Z.post("".concat(hostname).concat(endpoint), data, options).then(function(res) {
        return mapper(res.data);
    });
}
function createPurchase(params) {
    var queryParams = buildCreatePurchaseRequest(params);
    return deprecatedRequestByGET(END_POINTS.CREATE_PURCHASE, queryParams);
}
function getPurchaseById(params) {
    var queryParams = buildPurchaseByIdRequest(params);
    return deprecatedRequestByGET(END_POINTS.PURCHASE_BY_ID, queryParams);
}
function updatePurchaseById(params) {
    return requestByPOST({
        endpoint: END_POINTS.UPDATE_PURCHASE_BY_ID,
        data: buildUpdatePurchaseToBodyRequest(params),
        options: OPTIONS,
        hostname: params.hostname
    });
}
function updatePurchaseByIdAuthorized(params) {
    return requestByPOST({
        endpoint: END_POINTS.UPDATE_PURCHASE_BY_ID_AUTH,
        data: buildUpdatePurchaseToBodyRequest(params),
        options: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, OPTIONS), {
            withCredentials: true
        }),
        hostname: params.hostname
    });
}
function getPaymentMethods(params) {
    return (0,requests/* requestByGET */.DD)({
        endpoint: END_POINTS.PAYMENT_METHODS,
        data: buildPurchasePaymentMethodByIdRequest(params),
        mapper: mappers/* mapPaymentMethods */.no
    });
}
function createAlias(params) {
    return requestByPOST({
        endpoint: END_POINTS.CREATE_ALIAS,
        data: buildCreateAliasBodyRequest(params),
        hostname: params.hostname
    });
}
function createAliasVoucher(params) {
    return requestByPOST({
        endpoint: END_POINTS.CREATE_ALIAS_VOUCHER,
        data: buildCreateAliasBodyRequest(params),
        hostname: params.hostname
    });
}
function confirmPurchase(params) {
    return requestByPOST({
        endpoint: END_POINTS.PURCHASE_CONFIRMATION,
        data: buildConfirmPurchaseBodyRequest(params),
        options: CONFIRMATION_OPTIONS,
        hostname: params.hostname
    });
}
function confirmPurchaseAuthorized(params) {
    return requestByPOST({
        endpoint: END_POINTS.PURCHASE_CONFIRMATION_AUTH,
        data: buildConfirmPurchaseBodyRequest(params),
        options: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, CONFIRMATION_OPTIONS), {
            withCredentials: true
        }),
        hostname: params.hostname
    });
}
function confirmWorldlinePurchase(params) {
    return _confirmWorldlinePurchase.apply(this, arguments);
}
function _confirmWorldlinePurchase() {
    _confirmWorldlinePurchase = (0,src_async_to_generator/* default */.Z)(function(params) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                requestByPOST({
                    endpoint: END_POINTS.WORLDLINE_PURCHASE_CONFIRMATION,
                    data: buildConfirmWorldlinePurchaseBodyRequest(params),
                    options: CONFIRMATION_OPTIONS,
                    hostname: params.hostname
                })
            ];
        });
    });
    return _confirmWorldlinePurchase.apply(this, arguments);
}
function confirmWorldlinePurchaseAuthorized(params) {
    return _confirmWorldlinePurchaseAuthorized.apply(this, arguments);
}
function _confirmWorldlinePurchaseAuthorized() {
    _confirmWorldlinePurchaseAuthorized = (0,src_async_to_generator/* default */.Z)(function(params) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                requestByPOST({
                    endpoint: END_POINTS.WORLDLINE_PURCHASE_CONFIRMATION_AUTH,
                    data: buildConfirmWorldlinePurchaseBodyRequest(params),
                    options: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, CONFIRMATION_OPTIONS), {
                        withCredentials: true
                    }),
                    hostname: params.hostname
                })
            ];
        });
    });
    return _confirmWorldlinePurchaseAuthorized.apply(this, arguments);
}
function confirmWorldlinePurchase3ds(params) {
    return _confirmWorldlinePurchase3ds.apply(this, arguments);
}
function _confirmWorldlinePurchase3ds() {
    _confirmWorldlinePurchase3ds = _async_to_generator(function(params) {
        return _ts_generator(this, function(_state) {
            return [
                2,
                requestByGET({
                    endpoint: END_POINTS.WORLDLINE_PURCHASE_CONFIRMATION_3DS,
                    data: params,
                    options: CONFIRMATION_OPTIONS_GET,
                    hostname: params.hostname
                })
            ];
        });
    });
    return _confirmWorldlinePurchase3ds.apply(this, arguments);
}
function confirmPurchaseWithApplePay(params) {
    return _confirmPurchaseWithApplePay.apply(this, arguments);
}
function _confirmPurchaseWithApplePay() {
    _confirmPurchaseWithApplePay = (0,src_async_to_generator/* default */.Z)(function(params) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                requestByPOST({
                    endpoint: END_POINTS.WORLDLINE_APPLEPAY_CONFIRMATION,
                    data: buildConfirmApplePayPurchaseBodyRequest(params),
                    options: CONFIRMATION_OPTIONS,
                    hostname: params.hostname
                })
            ];
        });
    });
    return _confirmPurchaseWithApplePay.apply(this, arguments);
}
function confirmPurchaseWithApm(params) {
    return requestByPOST({
        endpoint: (0,url/* buildPathParams */.J0)(END_POINTS.PURCHASE_CONFIRMATION_APM, {
            paymentProvider: params.paymentProvider
        }),
        data: buildConfirmPurchaseBodyRequest(params),
        options: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, CONFIRMATION_OPTIONS), {
            withCredentials: true
        }),
        hostname: params.hostname
    });
}
function generateQuotePriceDropProtection(params) {
    return requestByPOST({
        endpoint: END_POINTS.PRICE_DROP_PROTECTION_QUOTE_GENERATE,
        data: params,
        options: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, OPTIONS), {
            withCredentials: true
        }),
        hostname: params.hostname
    });
}
function getPaymentStatus(params) {
    return (0,requests/* requestByGET */.DD)({
        endpoint: (0,url/* buildPathParams */.J0)(END_POINTS.PURCHASE_STATUS, {
            purchaseId: params.purchaseId
        }),
        options: OPTIONS_GET,
        hostname: params.hostname
    });
}


/***/ }),

/***/ 88113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ comps_TextArea; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(12411);
// EXTERNAL MODULE: ./client/styles/index.js + 4 modules
var styles = __webpack_require__(89804);
;// CONCATENATED MODULE: ./src/comps/TextArea/styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  min-height: 175px;\n  max-width: 100%;\n  width: 100%;\n  resize: vertical;\n  padding-block: 12px;\n  padding-inline: 14px;\n  background: ",
        ";\n  border: 2px solid ",
        ";\n  border-radius: 8px;\n  cursor: pointer;\n  font-family: ",
        ";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 150%;\n\n  outline: none;\n  color: ",
        ";\n\n  :hover {\n    border: 2px solid ",
        ";\n  }\n\n  :active,\n  :focus {\n    border: 2px solid ",
        ";\n  }\n\n  ::placeholder {\n    color: ",
        ";\n    font-weight: 500;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var TextAreaInput = styled_components_browser_esm/* default.textarea.withConfig */.ZP.textarea.withConfig({
    displayName: "styles__TextAreaInput",
    componentId: "sc-a9626d27-0"
})(_templateObject(), styles/* colors.grey1 */.O9.grey1, styles/* colors.white */.O9.white, styles/* colors.grey4 */.O9.grey4, function(props) {
    return props.theme.fonts.families.primary;
}, styles/* colors.grey1 */.O9.grey1, styles/* colors.grey1 */.O9.grey1, styles/* colors.grey2 */.O9.grey2, styles/* colors.grey2 */.O9.grey2);

;// CONCATENATED MODULE: ./src/comps/TextArea/index.js




var TextArea = function(param) {
    var onChange = param.onChange, name = param.name, role = param.role, value = param.value, placeholder = param.placeholder, id = param.id;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextAreaInput, {
        name: name,
        role: role,
        id: id,
        "data-testid": id,
        placeholder: placeholder,
        value: value,
        onChange: onChange
    });
};
TextArea.propTypes = {
    onChange: (prop_types_default()).func,
    name: (prop_types_default()).string,
    role: (prop_types_default()).string,
    value: (prop_types_default()).string,
    placeholder: (prop_types_default()).string,
    id: (prop_types_default()).string
};
/* harmony default export */ var comps_TextArea = (TextArea);


/***/ })

}]);